import web from "@/core/middlewares/web";
import prefix from "@/core/utils/prefix-routes";
let menuIndex = () => import(/* webpackChunkName: "menu" */ '@/views/sections/menu/Index.vue');
let menuShow = () => import(/* webpackChunkName: "menu" */ '@/views/sections/menu/Show.vue');
let subMenuShow = () => import(/* webpackChunkName: "menu" */ '@/views/sections/menu/Submenu.vue');
let certificate = () => import(/* webpackChunkName: "settings" */ '@/views/sections/Certificate.vue');
let sliderIndex = () => import(/* webpackChunkName: "slider" */ '@/views/sections/slider/Index.vue');
let sliderEdit = () => import(/* webpackChunkName: "slider" */ '@/views/sections/slider/Edit.vue');
let slideCreate = () => import(/* webpackChunkName: "slide" */ '@/views/sections/slider/slide/Create.vue');
let slideEdit = () => import(/* webpackChunkName: "slide" */ '@/views/sections/slider/slide/Edit.vue');
let socialsIndex = () => import(/* webpackChunkName: "social-networks" */ '@/views/sections/social-networks/Index');
let socialsCreate = () => import(/* webpackChunkName: "social-networks" */ '@/views/sections/social-networks/Create');
let header = () => import(/* webpackChunkName: "sections" */ '@/views/sections/Header');
let footer = () => import(/* webpackChunkName: "sections" */ '@/views/sections/Footer.vue');
let quickAccess = () => import(/* webpackChunkName: "sections" */ '@/views/sections/QuickAccess.vue');
let formsIndex = () => import(/* webpackChunkName: "paper-forms" */ '@/views/sections/paper-forms/Index');
let description = () => import(/* webpackChunkName: "description" */ '@/views/sections/Description.vue');
let TeamMembers = () => import(/* webpackChunkName: "team-members" */ '@/views/sections/TeamMembers.vue');
export default [
    ...prefix("/sections",[
        {
            path: "header",
            name: "sections.header",
            component: header,
            meta: {
                middleware: web,
                permissions: ['settings:header'],
                title: "تنظیمات لوگو"
            }
        },
        {
            path: "description",
            name: "sections.description",
            component: description,
            meta: {
                middleware: web,
                permissions: ['settings:mainPage'],
                title: "توضیحات صفحه اصلی"
            }
        },
        {
            path: "team-members",
            name: "sections.team-members",
            component: TeamMembers,
            meta: {
                middleware: web,
                permissions: ['team-members:update'],
                title: "تنظیمات اعضای تیم"
            }
        },
        {
            path: "footer",
            name: "sections.footer",
            component: footer,
            meta: {
                middleware: web,
                permissions: ['settings:footer'],
                title: "تنظیمات فوتر"
            }
        },
        {
            path: "menu",
            name: "sections.menu.index",
            component: menuIndex,
            meta: {
                middleware: web,
                permissions: ['menus:viewAny'],
                title: "منو ها"
            }
        },
        {
            path: "menu/:id",
            name: "sections.menu.show",
            component: menuShow,
            meta: {
                middleware: web,
                permissions: ['menus:viewAny'],
                title: "مشاهده زیرمنو"
            }
        },
        {
            path: "menu/:id/:submenu",
            name: "sections.submenu.show",
            component: subMenuShow,
            meta: {
                middleware: web,
                permissions: ['menus:viewAny'],
                title: "مشاهده زیرمنو سطح سوم"
            }
        },
        {
            path: "certificate",
            name: "sections.certificate",
            component: certificate,
            meta: {
                middleware: web,
                permissions: ['certificates:viewAny'],
                title: "نمادها"
            }
        },
        {
            path: "slider",
            name: "sections.slider",
            component: sliderIndex,
            meta: {
                middleware: web,
                permissions: ['sliders:viewAny','sliders:view'],
                title: "اسلایدر"
            }
        },
        {
            path: "slider/:id",
            name: "sections.slider.slide",
            component: sliderEdit,
            meta: {
                middleware: web,
                permissions: ['sliders:update','sliders:view'],
                title: "لیست اسلایدها"
            }
        },
        {
            path: "slider/:id/create",
            name: "sections.slider.slide.create",
            component: slideCreate,
            meta: {
                middleware: web,
                permissions: ['sliders:create'],
                title: "ایجاد اسلاید"
            }
        },
        {
            path: "slider/:slider/slide/:id",
            name: "sections.slider.slide.show",
            component: slideEdit,
            meta: {
                middleware: web,
                permissions: ['sliders:update','sliders:view'],
                title: "ویرایش اسلاید"
            }
        },
        {
            path: "quick-access",
            name: "sections.quick-access",
            component: quickAccess,
            meta: {
                middleware: web,
                permissions: ['quick-access-links:viewAny'],
                title: "  دسترسی سریع "
            }
        },
        {
            path: "social-networks",
            name: "sections.social-networks.index",
            component: socialsIndex,
            meta: {
                middleware: web,
                permissions: ['social-networks:viewAny'],
                title: "شبکه های اجتماعی"
            }
        },
        {
            path: "social-networks/create",
            name: "sections.social-networks.create",
            component: socialsCreate,
            meta: {
                middleware: web,
                permissions: ['social-networks:create'],
                title: "افزودن شبکه اجتماعی"
            }
        },
        {
            path: "paper-forms",
            name: "sections.paper-forms",
            component: formsIndex,
            meta: {
                middleware: web,
                permissions: ['paper-forms:viewAny'],
                title: "فرم ها"
            }
        },
    ])
]